export function Bank({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.3096 1.79219L17.8096 4.79217C18.1013 4.90883 18.3346 5.25883 18.3346 5.56716V8.33383C18.3346 8.79217 17.9596 9.16717 17.5013 9.16717H2.5013C2.04297 9.16717 1.66797 8.79217 1.66797 8.33383V5.56716C1.66797 5.25883 1.90131 4.90883 2.19297 4.79217L9.69297 1.79219C9.85964 1.72552 10.143 1.72552 10.3096 1.79219Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3346 18.3333H1.66797V15.8333C1.66797 15.375 2.04297 15 2.5013 15H17.5013C17.9596 15 18.3346 15.375 18.3346 15.8333V18.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33203 15.0013V9.16797"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66797 15.0013V9.16797"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15.0013V9.16797"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.332 15.0013V9.16797"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.668 15.0013V9.16797"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.832031 18.332H19.1654"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 7.08203C10.6904 7.08203 11.25 6.52239 11.25 5.83203C11.25 5.14168 10.6904 4.58203 10 4.58203C9.30964 4.58203 8.75 5.14168 8.75 5.83203C8.75 6.52239 9.30964 7.08203 10 7.08203Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
